/* Yester — carousel controls */
(function () {
  if (window.__uncialCarouselInit) return;
  window.__uncialCarouselInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function step(list, dir) {
    var card = list.querySelector('.u-card');
    if (!card) return;
    var gap = parseFloat(getComputedStyle(list).columnGap || 28) || 28;
    list.scrollBy({
      left: dir * (card.offsetWidth + gap),
      behavior: reduce.matches ? 'auto' : 'smooth'
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-uncial-scroll]');
    if (!btn) return;
    var list = document.getElementById(btn.dataset.target);
    if (list) step(list, parseInt(btn.dataset.uncialScroll, 10));
  });

  document.addEventListener('keydown', function (e) {
    var list = e.target.closest('.u-carousel');
    if (!list) return;
    if (e.key === 'ArrowRight') { step(list, 1); e.preventDefault(); }
    if (e.key === 'ArrowLeft')  { step(list, -1); e.preventDefault(); }
  });
})();

/* Yester - product gallery */
(function () {
  if (window.__uncialGalleryInit) return;
  window.__uncialGalleryInit = true;

  function frames(main) {
    return Array.prototype.slice.call(main.querySelectorAll('.u-pdp__frame'));
  }

  function currentIndex(main) {
    var active = main.querySelector('.u-pdp__frame.is-active');
    return active ? (parseInt(active.dataset.index, 10) || 0) : 0;
  }

  // Clamp the media wrapper to the rendered width of the active image, so the
  // arrows hug the image and the thumbnail strip wraps instead of running wider
  // than the main photo. The active image is measured at its natural (height-
  // capped) width; if it's narrower than the column, the column is pinned to it.
  function sizeMedia(gallery) {
    if (!gallery) return;
    var media = gallery.querySelector('.u-pdp__media');
    if (!media) return;
    var img = media.querySelector('.u-pdp__frame.is-active img');
    if (!img) return;
    function measure() {
      media.style.removeProperty('--u-img-w');
      var imgW = img.getBoundingClientRect().width;
      var colW = media.getBoundingClientRect().width;
      if (imgW > 0 && imgW < colW - 1) {
        media.style.setProperty('--u-img-w', Math.round(imgW) + 'px');
      }
    }
    // Measure on the next frame so the image has settled at its final,
    // height-capped size before we pin the wrapper to it.
    function apply() { requestAnimationFrame(measure); }
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }

  // Single source of truth: show frame i, sync thumbs, and set arrow visibility.
  function activate(main, i) {
    var fs = frames(main);
    if (!fs.length) return;
    if (i < 0) i = 0;
    if (i > fs.length - 1) i = fs.length - 1;
    var idx = String(i);

    fs.forEach(function (f) {
      f.classList.toggle('is-active', f.dataset.index === idx);
    });

    var gallery = main.closest('.u-pdp__gallery') || main.parentElement;
    if (gallery) {
      var strip = gallery.querySelector('.u-pdp__thumbs');
      if (strip) {
        strip.querySelectorAll('.u-thumb').forEach(function (t) {
          var on = t.dataset.index === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
    }

    var prev = main.querySelector('.u-gallery-arrow--prev');
    var next = main.querySelector('.u-gallery-arrow--next');
    if (prev) prev.hidden = (i <= 0);
    if (next) next.hidden = (i >= fs.length - 1);

    if (gallery) sizeMedia(gallery);
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.u-gallery-arrow');
    if (arrow) {
      var m = arrow.closest('.u-pdp__main');
      if (!m) return;
      var dir = parseInt(arrow.dataset.galleryNav, 10) || 0;
      activate(m, currentIndex(m) + dir);
      return;
    }

    var thumb = e.target.closest('.u-thumb');
    if (!thumb) return;
    var main = document.getElementById(thumb.dataset.target);
    if (!main) return;
    activate(main, parseInt(thumb.dataset.index, 10) || 0);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target.closest('.u-thumb');
    if (!t) return;
    var strip = t.parentElement;
    var all = Array.prototype.slice.call(strip.querySelectorAll('.u-thumb'));
    var i = all.indexOf(t);
    var next = null;
    if (e.key === 'ArrowRight') next = all[i + 1];
    if (e.key === 'ArrowLeft') next = all[i - 1];
    if (next) { next.focus(); next.click(); e.preventDefault(); }
  });

  function sizeAllMedia() {
    Array.prototype.slice.call(document.querySelectorAll('.u-pdp__gallery')).forEach(sizeMedia);
  }

  // Correct the arrow visibility for galleries already in the DOM at load.
  Array.prototype.slice.call(document.querySelectorAll('.u-pdp__main')).forEach(function (main) {
    if (main.querySelector('.u-gallery-arrow')) activate(main, currentIndex(main));
  });
  sizeAllMedia();
  window.addEventListener('load', sizeAllMedia);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sizeAllMedia, 150);
  });

  // Warm the non-active gallery images once the page is idle, so switching to
  // another photo is instant instead of waiting on a fetch. Non-active frames
  // are display:none + loading="lazy", so the browser won't fetch them until
  // they're revealed; promoting them to eager after first paint pre-loads them
  // without competing with the initial render. Scoped to the product gallery.
  function warmGallery() {
    Array.prototype.slice
      .call(document.querySelectorAll('.u-pdp__frame img[loading="lazy"]'))
      .forEach(function (img) { img.loading = 'eager'; });
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmGallery, { timeout: 2500 });
  } else {
    window.addEventListener('load', function () { setTimeout(warmGallery, 400); });
  }
})();

/* Yester - mobile drawer */
(function () {
  if (window.__uncialDrawerInit) return;
  window.__uncialDrawerInit = true;

  function drawerFor(btn) {
    var id = btn.getAttribute('aria-controls');
    return document.getElementById(id);
  }
  function openDrawer(drawer, btn) {
    var overlay = drawer.parentElement.querySelector('[data-u-overlay]');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function(){ overlay.classList.add('is-open'); }); }
    if (btn) btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('u-drawer-open');
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }
  function closeDrawer(drawer, btn) {
    var overlay = drawer.parentElement.querySelector('[data-u-overlay]');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(function(){ overlay.hidden = true; }, 350); }
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    document.body.classList.remove('u-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-u-burger]');
    if (burger) { openDrawer(drawerFor(burger), burger); return; }

    var closeBtn = e.target.closest('[data-u-close]');
    if (closeBtn) {
      var d = closeBtn.closest('.u-drawer');
      var b = document.querySelector('[aria-controls="' + d.id + '"]');
      closeDrawer(d, b); return;
    }

    var overlay = e.target.closest('[data-u-overlay]');
    if (overlay) {
      var dr = overlay.parentElement.querySelector('.u-drawer');
      var bb = document.querySelector('[aria-controls="' + dr.id + '"]');
      closeDrawer(dr, bb); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.u-drawer.is-open');
    if (open) {
      var b = document.querySelector('[aria-controls="' + open.id + '"]');
      closeDrawer(open, b);
    }
  });
})();

/* Yester - collections slideshow (dots, autoplay, swipe via native scroll-snap) */
(function () {
  if (window.__yesterSlidesInit) return;
  window.__yesterSlidesInit = true;

  function setup(root) {
    var track = root.querySelector('[data-u-track]');
    var dotsEl = root.querySelector('[data-u-dots]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-u-slide]'));
    if (!track || !dotsEl || !slides.length) return;

    var desktop = window.matchMedia('(min-width: 900px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce.matches;
    var perView = 1, pages = 1, current = 0, timer = null, paused = false, scrollTimer = null;

    function buildDots() {
      perView = desktop.matches ? 2 : 1;
      pages = Math.max(1, Math.ceil(slides.length / perView));
      dotsEl.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'u-slides__dot';
        b.setAttribute('aria-label', 'Show slide ' + (i + 1) + ' of ' + pages);
        b.addEventListener('click', (function (p) { return function () { goTo(p); restart(); }; })(i));
        dotsEl.appendChild(b);
      }
      dotsEl.style.display = pages > 1 ? '' : 'none';
      if (current >= pages) current = 0;
      mark();
    }

    function mark() {
      var dots = dotsEl.children;
      for (var i = 0; i < dots.length; i++) dots[i].setAttribute('aria-current', i === current ? 'true' : 'false');
    }

    function goTo(p) {
      current = (p + pages) % pages;
      var target = slides[current * perView];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      mark();
    }

    function next() { if (!paused) goTo(current + 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (autoplay && pages > 1) timer = setInterval(next, interval); }
    function restart() { start(); }

    // keep dots in step with swipes / trackpad scrolling
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth || 1;
        var p = Math.round(track.scrollLeft / w);
        if (p !== current && p >= 0 && p < pages) { current = p; mark(); }
      }, 90);
    }, { passive: true });

    // pause while the visitor is looking or touching
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; restart(); }, 2500); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    var onChange = function () { buildDots(); goTo(current); start(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange); else desktop.addListener(onChange);

    buildDots();
    start();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-u-slides]')).forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-u-slides]');
    if (el) setup(el);
  });
})();
